/**
 * @flow
 */

import { fromJS } from 'immutable';
import { SELECT_EVENT } from './actions';

const initialState = fromJS({
  selectedEvent: null
});

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case SELECT_EVENT:
      return fromJS({
        selectedEvent: action.eventId
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/event/reducer.js